export default __webpack_public_path__ + "static/media/sent-email-blue.4a6335a6.svg";